import type { DayKind } from '@trippath/shared';

/** Each kind's drawing, after Lucide's (ISC licence): a beach umbrella, a thermometer, a laptop. */
const PATHS: Record<DayKind, string> = {
  leave: 'M3 21h18M12 12v9M2 12a10 10 0 0 1 20 0zM12 2v1',
  sick: 'M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z',
  work: 'M4 5h16v10H4zM2 19h20',
};

/** What a person's day is, drawn: on leave, sick, or working while away. */
export function DayKindIcon({ kind, size = 14 }: { kind: DayKind; size?: number }) {
  return (
    <svg
      className={`day-kind-icon kind-${kind}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[kind]} />
    </svg>
  );
}
